








































import { Component, Vue, Inject, Prop } from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../lib/ajax'
import AbpBase from '../../lib/abpbase'
import ImportModal from "../tools/importModal.vue";
@Component({
	components: {
		ImportModal
	}
})
export default class QuickTable extends AbpBase  {
	// 请求地址
	@Prop({type:String}) request:string;
	// 表格头 Array
	@Prop({type:Array}) columns:Array<any>;
	// 搜索数据 Object
	@Prop({type:Object}) search:any;
	// 是否分页
	@Prop({type:Boolean, default: true}) page:boolean;
	// 导入接口地址
	@Prop(String) importPath:string;
	// 导出配置，没有配置则表示不需要导出，url为空时会disabled按钮，格式{url: '', fileName: ''}
	@Prop(Object) exports:object;
	initData:any = {
		totalCount: 0,				// 数据总数
		content: [],				// 表格数据
		loading: false,				// 表格加载
		searchData: {},				// 表格数据搜索
		exportLoading: false,		// 文件导出加载中
		showImportModal: false,		// 导入弹出
	}
	//分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    // 获取数据
    async GetData() {
    	let params:any = {};
    	if(this.search) {
    		for(let k in this.search) {
    			params[k] = this.search[k];
    		}
    	}
    	if(this.initData.searchData.SkipCount) {
    		params.SkipCount = this.initData.searchData.SkipCount;
    	}
    	if(this.initData.searchData.MaxResultCount) {
    		params.MaxResultCount = this.initData.searchData.MaxResultCount;
    	}
        this.initData.loading = true;
        await Ajax.get(this.request, {params: params}).then((res:any)=>{
            if(res.data.result){
                this.initData.content = res.data.result.items;
				this.initData.totalCount = res.data.result.totalCount;
				console.log(this.initData.content)
            }else{
                this.$Message.error('暂无数据！');
                this.initData.content = [];
                this.initData.totalCount = 0;
            }
            this.initData.loading = false;
        })
    }
    // 导入回调
    handleImportCallback() {
    	this.GetData();
    }
    // 导出
    Export() {
    	let exports:any = this.exports;
    	if(!exports || !exports.url) return;
    	if(!exports) exports = {};
    	(this as any).$root.Export(this.initData.searchData, exports.url, exports.fileName, 'xlsx');
    	/*let exports:any = this.exports;
    	if(this.initData.exportLoading || !exports || !exports.url) return;
    	this.initData.exportLoading = true;
    	if(!exports) exports = {};
        Ajax.post(exports.url, {params: this.initData.searchData}, {responseType: 'blob'}).then((res:any)=>{
            const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' })
            const fileName = (exports.fileName ? exports.fileName : '下载数据') + '.xlsx';
            if ('download' in document.createElement('a')) { // 非IE下载
                const elink = document.createElement('a')
                elink.download = fileName
                elink.style.display = 'none'
                elink.href = URL.createObjectURL(blob)
                document.body.appendChild(elink)
                elink.click()
                URL.revokeObjectURL(elink.href) // 释放URL 对象
                document.body.removeChild(elink)
            } else { // IE10+下载
                navigator.msSaveBlob(blob, fileName)
            }
            this.initData.exportLoading = false;
        }).catch(() => {
        	this.initData.exportLoading = true;
        })*/
    }
    mounted() {
    	this.GetData();
    }
}
